import { useEffect } from "react";
import { FieldArray, useFormContext } from "react-hook-form";

// We're copying Google Forms
// which means we want the option to be focused and selected when we click on "Add option"
// when you append a new option, the input doesn't exist in the DOM yet
// so we need useEffect

export function useAutoFocusOnLastOption(fields: FieldArray[]) {
    const { setFocus } = useFormContext();

    useEffect(() => {
        if (fields.length > 0) {
            const lastIndex = fields.length - 1;
            setFocus(`options.${lastIndex}.name`, { shouldSelect: true });
        }
    }, [fields.length, setFocus]);
}
